import { ComplexConfiguration } from '../ComplexConfiguration';

export function changesInVersion8(
    oldConfiguration: any,
    dataRequiredToUpdate: {}
): ComplexConfiguration {

    const {allFields, ...oldConfigurationLeft} = oldConfiguration;
    const configuration: ComplexConfiguration = {
        ...oldConfigurationLeft,
        $version: 8,
        fields: {},
        sketchMainData: oldConfigurationLeft.sketchMainData?.length ? JSON.parse(oldConfigurationLeft.sketchMainData) : null
    };

    allFields.forEach(field => {
        configuration.fields[field.id] = {
            id: field.id,
            featureId: field.productFeature.id,
            name: field.name,
            nameCms: field.nameCms,
            type: field.type,
            value: field.value,
            readableValue: field.readableValue,
            valueSetByUser: field.valueSetByUser,
            invalidValue: field.invalidValue,
            defaultValue: field.currentDefaultValue,
            hiddenInConfigurator: field.currentHiddenInConfigurator,
            hiddenInSummary: field.currentHiddenInSummary,
            changedHiddenInConfiguratorByRule: field.changeInConfiguratorByRule,
            changedHiddenInSummaryByRule: field.changeInSummaryByRule,
            ranges: field.currentRanges,
            price: field.currentPrice,
            productFeatureOptionsIds: (field.productFeature?.currentProductFeatureOptions || []).map(el => el.id),
            productFeatureOptions: {},
        };
        (field.productFeature?.currentProductFeatureOptions || []).forEach(option => {
            configuration.fields[field.id].productFeatureOptions[option.id] = {
                value: option.value,
                img: option.img,
                widthMM: option.widthMM,
                heightMM: option.heightMM,
                disabled: option.disabled,
                info: option.info,
            };
        })
    });

    if (configuration.sketchMainData) {
        delete (configuration.sketchMainData as any).details;
    }

    return configuration;
}
